import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants';
import { API_ROUTES } from '../constants/apiRoutes';
import type { FinpspPayment } from '../types/finpsp';
import { getData } from '../utils/api';
import { finpspPaymentSchema } from '../schemas/finpsp';
import { isFinpspTerminal } from '../helpers/payment/finpsp';

export const getFinpspPaymentKey = (
  marketplaceId: string | null | undefined,
  userId: string | null | undefined,
  transactionId: string
) => [QUERY_KEYS.finpspPayment, marketplaceId, userId, transactionId];

export const useFinpspPayment = (transactionId: string, pollInterval?: number) => {
  const { isAuthenticated, marketplaceId, userId } = useAuth();

  return useQuery<FinpspPayment>({
    queryKey: getFinpspPaymentKey(marketplaceId, userId, transactionId),
    queryFn: async () =>
      finpspPaymentSchema.parse(await getData(API_ROUTES.FINPSP.PAYMENT(transactionId), undefined, 'wallet')),
    enabled: isAuthenticated && !!transactionId,
    retry: false,
    gcTime: 0,
    refetchInterval: (query) => (pollInterval && !isFinpspTerminal(query.state.data) ? pollInterval : false),
    refetchIntervalInBackground: false,
  });
};
